import axios from "axios"
import { ADD_TO_CART, EMPTY_CART, REMOVE_FROM_CART, SAVE_SHIPPING_INFO, SAVE_PROMO_CODE, REMOVE_PROMO_CODE } from "../constants/cartConstants";

// add to cart
export const addItemsToCart = (id, quantity = 1) => async (dispatch, getState) => {
    const { data } = await axios.get(`/api/v1/product/${id}`);

    dispatch({
        type: ADD_TO_CART,
        payload: {
            product: data.product._id,
            name: data.product.name,
            seller: data.product.brand?.name || "1313 Mart",
            price: data.product.price,
            cuttedPrice: data.product.cuttedPrice,
            image: data.product.images && data.product.images.length > 0 ? data.product.images[0].url : "https://placehold.co/300x300?text=No+Image",
            stock: data.product.stock,
            quantity,
        },
    });

    localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems))
}

// remove cart item
export const removeItemsFromCart = (id) => async (dispatch, getState) => {

    dispatch({
        type: REMOVE_FROM_CART,
        payload: id,
    });

    localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems))
}

// empty cart
export const emptyCart = () => async (dispatch, getState) => {

    dispatch({ type: EMPTY_CART });

    localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems))
}

// save shipping info
export const saveShippingInfo = (data) => async (dispatch) => {

    dispatch({
        type: SAVE_SHIPPING_INFO,
        payload: data,
    });

    localStorage.setItem('shippingInfo', JSON.stringify(data));
}

// save promo code — stores only the code string; the actual discount is
// always revalidated fresh against the current subtotal wherever it's
// shown, never trusted/cached
export const savePromoCode = (code) => (dispatch) => {

    dispatch({
        type: SAVE_PROMO_CODE,
        payload: code,
    });

    localStorage.setItem('promoCode', code);
}

// remove promo code
export const removePromoCode = () => (dispatch) => {

    dispatch({ type: REMOVE_PROMO_CODE });

    localStorage.removeItem('promoCode');
}